import React, { Component } from 'react';
import { acessoPermitido } from '../../../acessos.seguranca';
import MultiErratasPage from '@common/multierratas/multierratas.page';
import WebapiCommon from '@common/util/webapi.common';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as commonActions from '@common/common.action';
import * as actions from '../../../pages/laudo/etapas/erratas/erratas.action';
import { getUsuarioLocalStorage } from '../../../localStorage.util';
import ErrataApi from './multierratas.api';

class MultiErratasContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      listagemErratas: [],
      medicos: [],
      medicoselecionado: null,
    };
  }

  render() {
    return (
      <MultiErratasPage
        usuario={this.props.usuario}
        acessoPermitido={acessoPermitido}
        listagemErratas={this.state.listagemErratas}
        medicos={this.state.medicos}
        medicoselecionado={this.state.medicoselecionado}
        stateUpdate={this.stateUpdate.bind(this)}
      />
    );
  }

  atualizarErrata(value) {
    this.props.actions.atualizarErrata(value);
  }

  async componentDidMount() {
    // let laudo = this.props.laudo;
    this.props.commonActions.showFadeCarregando(true);
    Promise.all([
      ErrataApi.listarErratas(this.props.detalhes.laudo),
      WebapiCommon.getMedicos(),
    ]).then((response) => {
      let getMedicosResponse = response[1];
      let erratas = response[0].data;
      let usuarioLocalStorage = getUsuarioLocalStorage();
      let medicoselecionado = null;

      if (usuarioLocalStorage) {
        medicoselecionado = {
          value: usuarioLocalStorage.medicoId,
          label:
            usuarioLocalStorage.medicoId + ' - ' + usuarioLocalStorage.medico,
        };
      }

      this.setState({
        laudo: this.props.laudo,
        listagemErratas: erratas,
        medicos: getMedicosResponse,
        medicoselecionado,
      });

      this.props.commonActions.showFadeCarregando(false);
    });

    const setRows = (id) => {
      if (id) {
        return id.getElementsByTagName('tr');
      }
    };

    const onRowClick = async (tableId, callback) => {
      return new Promise((resolve) => {
        if (!tableId) {
          return;
        }

        const props = this.props;
        let table, rows, i;

        try {
          table = document.getElementById(tableId);
          rows = table.getElementsByTagName('tr');

          const checkExist = setInterval(function () {
            if (rows && rows[0].innerHTML.indexOf('loader') < 0) {
              clearInterval(checkExist);
              for (i = 0; i < rows.length; i++) {
                table.rows[i].onclick = (function (row) {
                  return function () {
                    callback(row, props);
                  };
                })(table.rows[i]);
              }
            } else {
              if (table && rows) {
                table = document.getElementById(tableId);
                rows = setRows(table);
                return;
              } else {
                clearInterval(checkExist);
              }
            }
          }, 300); // check every 100ms
        } catch (error) {
         return setTimeout(() => {
          onRowClick(tableId, callback);
         }, 600); 
        }
        resolve();
      });
    };

    await onRowClick('erratas-table', function (row, props) {
      if (row.className === 'thead') {
        return;
      }
      const id = row.getElementsByTagName('td')[0].innerHTML;
      if (row.getAttribute('style')) {
        return;
      }

      const rows = document.getElementsByTagName('tr');
      for (let index = 0; index < rows.length; index++) {
        const element = rows[index];
        element.setAttribute('style', '');
      }
      row.setAttribute('style', 'background: #ccc');
      //console.log('ID>>', id);

      WebapiCommon.getTextoLaudoByID(props.detalhes.laudo, 'errata', id)
        .then((res) => {
          props.actions.atualizarErrata(res.data);
          props.actions.selectErrata(true);
        })
        .catch((err) => {
          props.actions.atualizarErrata({});
          props.actions.selectErrata(false);
        });
    });
  }

  adicionarErrata() {
    this.props.commonActions.showFadeCarregando(true);
  }

  stateUpdate = (name, value) =>
    this.setState({
      [name]: value,
    });

  limparNovosRegistros = () => this.setState({ novosregistros: [] });
}

const mapsDispacthToProps = (dispatch) => {
  return {
    actions: bindActionCreators(actions, dispatch),
    commonActions: bindActionCreators(commonActions, dispatch),
  };
};

const mapStateToProps = (state) => {
  return {
    usuario: state.usuario,
    detalhes: state.commonReducer.detalhes,
  };
};

export default connect(
  mapStateToProps,
  mapsDispacthToProps
)(MultiErratasContainer);



// WEBPACK FOOTER //
// ./src/app/common/multierratas/multierratas.container.js